import { Moment } from 'moment';

export type PortCallWithDeparture = {
	departureDate?: Moment | null;
	estimatedDepartureDate?: Moment | null;
};

const getEffectiveDeparture = (portCall: PortCallWithDeparture): Moment | null => (
	portCall.departureDate ?? portCall.estimatedDepartureDate ?? null
);

/**
 * Current port: among ports where ATD (or ETD if no ATD) is after today,
 * the one with the smallest effective departure date.
 */
export const getCurrentPortCallIndex = <T extends PortCallWithDeparture>(
	portCalls: T[],
	today: Moment,
): number => {
	const startOfToday = today.clone().startOf('day');

	const candidates = portCalls
		.map((pc, index) => ({ index, date: getEffectiveDeparture(pc) }))
		.filter(({ date }) => date != null && date.isAfter(startOfToday));

	if (candidates.length === 0) {
		return -1;
	}

	candidates.sort((a, b) => a.date!.valueOf() - b.date!.valueOf());

	return candidates[0].index;
};

export const getFutureItineraryPortCalls = <T extends PortCallWithDeparture>(
	portCalls: T[],
	today: Moment,
): T[] => {
	const currentIndex = getCurrentPortCallIndex(portCalls, today);

	if (currentIndex < 0) {
		return [];
	}

	return portCalls.slice(currentIndex);
};
